import React, { Component } from "react";
import PropTypes from "prop-types";
import { ImageBackground, Modal, Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { Body, Button, Content, Left, Right, Text, Title } from "native-base";
import FontAwesomeIcon from "react-native-vector-icons/dist/FontAwesome";
import FontAwesome5Icon from "react-native-vector-icons/dist/FontAwesome5";
import Svg, { Line } from "react-native-svg";
import Icon from "react-native-vector-icons/Ionicons";
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import Header from "./WrappedHeader";
import * as Helper from "../../utils/Helper";
import Dimensions from "react-native-web-dimension-helper";

//import SignatureScreen from "react-native-signature-canvas";
//import RNSketchCanvas from "@terrylinla/react-native-sketch-canvas";
import SignatureCapture from "react-native-signature-capture";

const uid = UIDs.components.ui.sketchCanvasModal;

class SketchCanvasModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editId: "",
            modalVisible: false,
            isEmpty: true,
            showErrorMsg: false,
        };
    }

    static defaultProps = {
        char: "",
        transparent: false,
        bgSrc: "",
        imgWidth: Helper.getContainerSize().width * 0.75 > 500 ? 500 : Helper.getContainerSize().width,
        imgHeight: Helper.getContainerSize().width * 0.75 > 500 ? 500 : Helper.getContainerSize().width,
        useAddIcon: false,
    };

    static propTypes = {
        char: PropTypes.string,
        transparent: PropTypes.bool,
        onSave: PropTypes.func,
        bgSrc: PropTypes.string,
        imgWidth: PropTypes.number,
        imgHeight: PropTypes.number,
        useAddIcon: PropTypes.bool,
    };

    componentWillUnmount() {
        this._setCloseState();
    }

    _setCloseState = () => {
        this.setState({
            modalVisible: false,
        });
    };

    _close = () => {
        this.setState({
            showErrorMsg: false,
            modalVisible: false,
        });
    };

    _open = editId => {
        this.setState({
            editId: editId,
            modalVisible: true,
        });
    };

    _onCloseModalPress() {
        this.show(false);
    }

    _saveSign() {
        if (!this.state.isEmpty) {
            this.setState({
                showErrorMsg: false,
            });
            this.refs["sign"].saveImage();
        } else {
            this.setState({
                showErrorMsg: true,
            });
        }
    }

    _resetSign() {
        this._resetStatValue();
        this.refs["sign"].resetImage();
    }

    _onDragEvent = () => {
        this.setState({
            isEmpty: false,
        });
        // This callback will be called when the user enters signature
        console.log("dragged");
    };

    _onSaveEvent = result => {
        if (!this.state.isEmpty) {
            //result.encoded - for the base64 encoded png
            //result.pathName - for the file path name
            if (this.state.editId) {
                result.editId = this.state.editId;
            }
            this.props.onSave && this.props.onSave(result);

            setTimeout(() => {
                this._resetStatValue();
                this._close();
            }, 100);
        }
    };

    _resetStatValue() {
        this.setState({
            showErrorMsg: false,
            isEmpty: true,
        });
    }

    renderContent() {
        return (
            <View style={{ flexDirection: "column" }}>
                <View style={styles.row}>
                    {this.state.showErrorMsg ? (
                        <View style={[styles.alignItemsCenter, styles.mg10, {flex:1, paddingTop:10}]}>
                            <Text style={{ color: "red", fontSize: 16 }}>{this.props.t("emptySignature")}</Text>
                        </View>
                    ) : null}
                    <TouchableOpacity style={styles.rightAligned} transparent onPress={() => this._resetSign()}>
                        <FontAwesome5Icon name="undo-alt" style={[styles.headerRightIconSelectedColor, styles.headerRightIconTrans]}></FontAwesome5Icon>
                    </TouchableOpacity>
                </View>
                {this.props.unitType==="POLA1" ?
                    <View style={{alignItems:"center"}}>
                        <Svg width={200} height={200} style={{border:"1px solid #DDD", marginBottom:"-200px"}}>
                            <Line x1="0" y1="0" x2="200" y2="200" stroke="#DDD" strokeWidth="1.5" />
                            <Line x1="199" y1="0" x2="0" y2="199" stroke="#DDD" strokeWidth="1.5" />
                            <Line x1="100" y1="0" x2="100" y2="200" stroke="#DDD" strokeWidth="1.5" />
                            <Line x1="0" y1="100" x2="200" y2="100" stroke="#DDD" strokeWidth="1.5" />
                        </Svg>
                        <SignatureCapture
                            ref="sign"
                            style={{ flex: 1, height: this.props.imgHeight, width: this.props.imgWidth }}
                            saveImageFileInExtStorage={false}
                            showTitleLabel={false}
                            showBorder={false}
                            showNativeButtons={false}
                            maxSize={200}
                            onDragEvent={this._onDragEvent}
                            onSaveEvent={this._onSaveEvent}
                            strokeColor={"#000000"}
                            backgroundColor={"transparent"}
                            minStrokeWidth={30}
                            maxStrokeWidth={30}
                        />
                    </View>
                :this.props.bgSrc ? (
                    <ImageBackground source={{ uri: this.props.bgSrc }} style={{ width: this.props.imgWidth, height: this.props.imgHeight, alignSelf: "center" }} resizeMode={"stretch"}>
                        <View style={[styles.borderGray, { backgroundColor: "transparent", height: this.props.imgHeight, width: this.props.imgWidth, justifyContent: "center", alignItems: "center" }]}>
                            <SignatureCapture
                                ref="sign"
                                style={{ flex: 1, height: this.props.imgHeight, width: this.props.imgWidth }}
                                saveImageFileInExtStorage={false}
                                showTitleLabel={false}
                                showBorder={false}
                                showNativeButtons={false}
                                maxSize={200}
                                onDragEvent={this._onDragEvent}
                                onSaveEvent={this._onSaveEvent}
                                strokeColor={"#000000"}
                                backgroundColor={"transparent"}
                                minStrokeWidth={30}
                                maxStrokeWidth={30}
                            />
                        </View>
                    </ImageBackground>
                ) : (
                    <View style={[styles.borderGray, { backgroundColor: "transparent", height: this.props.imgHeight, width: this.props.imgWidth, justifyContent: "center", alignSelf: "center" }]}>
                        <SignatureCapture
                            ref="sign"
                            style={{ flex: 1, height: this.props.imgHeight, width: this.props.imgWidth }}
                            saveImageFileInExtStorage={false}
                            showTitleLabel={false}
                            showBorder={false}
                            showNativeButtons={false}
                            maxSize={200}
                            onDragEvent={this._onDragEvent}
                            onSaveEvent={this._onSaveEvent}
                            strokeColor={"#000000"}
                            backgroundColor={"transparent"}
                        />
                    </View>
                )}
            </View>
        );
    }

    render() {
        return (
            <View style={this.props.style || styles.container}>
                <View style={{ flex: 1, flexDirection: "row" }}>
                    {this.props.isReadonly ? null : !this.props.useAddIcon ? (
                        <TouchableOpacity transparent style={{ justifyContent: "center", alignItems: "center" }} onPress={() => this._open()}>
                            <FontAwesomeIcon name="pencil" allowFontScaling={true} style={[styles.headerRightIconSelectedColor, styles.headerRightIconTrans]}></FontAwesomeIcon>
                        </TouchableOpacity>
                    ) : (
                        <TouchableOpacity transparent onPress={() => this._open()}>
                            <Icon name="ios-add-circle" allowFontScaling={true} style={[styles.headerRightIconSelectedColor, styles.customRightIcon]}></Icon>
                        </TouchableOpacity>
                    )}
                    <Modal
                        animationType={"none"}
                        transparent={false}
                        visible={this.state.modalVisible}
                        onRequestClose={() => {
                            this._close();
                        }}>
                        <div style={{width: Helper.getContainerSize().width, margin:"0 auto"}}>
                        <Header style={styles.headerColor}>
                            <Left style={[styles.flex1]}>
                                <Button transparent onPress={() => this._close()}>
                                    <Icon name="ios-arrow-back" style={[styles.headerIcon]} />
                                </Button>
                            </Left>
                            <Body style={[styles.flex3, styles.alignItemsCenter]}>
                                <Title style={[styles.headerTitle]}>{this.props.char !== "" ? this.props.char : this.props.t("title")}</Title>
                            </Body>
                            <Right style={[styles.flex1]}>
                                <Button transparent onPress={() => this._saveSign()}>
                                    <Text style={[styles.headerTitle]}>{this.props.t("save")}</Text>
                                </Button>
                            </Right>
                        </Header>
                        {this.props.imgWidth > Helper.getContainerSize().width ? <Content>{this.renderContent()}</Content> : this.renderContent()}
                        </div>
                    </Modal>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
    },
    headerRightIconSelectedColor: {
        color: "#333",
    },
    headerRightIconLetter: {
        fontSize: 24,
        left: -13,
    },
    customRightIcon: {
        fontSize: Platform.OS === "ios" ? 22 : 18,
        marginTop: -4,
    },
    headerRightIconTrans: {
        fontSize: 17,
    },
    headerColor: {
        backgroundColor: "#fff",
    },

    headerTitle: {
        color: "#111",
    },

    flex1: {
        flex: 1,
    },
    alignItemsCenter: {
        alignItems: "center",
    },
    headerIcon: {
        fontSize: 30,
        color: "#777",
    },
    leftAligned: {
        alignItems: "flex-start",
    },
    rightAligned: {
        alignItems: "flex-end",
        margin: 20,
    },
    borderGray: {
        borderWidth: 2,
        borderColor: "#cccccc",
    },
    row: {
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    mg10: {
        margin: 10,
    },
});

export default withTranslation(uid, { withRef: true })(SketchCanvasModal);
